/**
 * Shared constants for MACROSCOPE.
 */
export const APP_NAME = "MACROSCOPE";
export const APP_VERSION = "0.1.0";
export const MAJOR_ECONOMIES = ["US", "EA", "GB", "JP", "CN", "CA", "AU", "CH"];
export const FX_MAJORS = [
    { pair: "EURUSD", base: "EUR", quote: "USD" },
    { pair: "GBPUSD", base: "GBP", quote: "USD" },
    { pair: "USDJPY", base: "USD", quote: "JPY" },
    { pair: "AUDUSD", base: "AUD", quote: "USD" },
    { pair: "USDCAD", base: "USD", quote: "CAD" },
    { pair: "USDCHF", base: "USD", quote: "CHF" },
];
export const HEADLINE_INSTRUMENTS = [
    { symbol: "DXY", name: "US Dollar Index", asset_class: "fx" },
    { symbol: "US10Y", name: "US 10Y Yield", asset_class: "rates" },
    { symbol: "XAU", name: "Gold", asset_class: "commodity" },
    { symbol: "WTI", name: "Crude Oil", asset_class: "commodity" },
    { symbol: "SPX", name: "S&P 500", asset_class: "equity" },
    { symbol: "BTC", name: "Bitcoin", asset_class: "crypto" },
];
export const PERSONAS = [
    {
        id: "fx_day_trader",
        label: "FX Day Trader",
        default_instruments: ["EURUSD", "GBPUSD", "USDJPY", "DXY"],
    },
    {
        id: "index_scalper",
        label: "Index / Futures Scalper",
        default_instruments: ["ES", "NQ", "SPX", "VIX"],
    },
    {
        id: "commodities_swing",
        label: "Commodities Swing Trader",
        default_instruments: ["XAU", "WTI", "COPPER", "NATGAS"],
    },
    {
        id: "crypto_macro",
        label: "Crypto Macro Trader",
        default_instruments: ["BTC", "ETH", "DXY", "US10Y"],
    },
    {
        id: "options_vol",
        label: "Options / Vol Trader",
        default_instruments: ["VIX", "SPX", "EURUSD", "USDJPY"],
    },
];
export const DEFAULT_PERSONA = "fx_day_trader";
// Free-tier daily budgets (units are provider-native where applicable)
export const PROVIDER_BUDGETS = {
    FRED: { daily: 5000, warn_at: 0.75 }, // 120 req/min; we cron, so daily is generous
    FRANKFURTER: { daily: 5000, warn_at: 0.75 }, // no documented hard cap; generous
    GDELT: { daily: 5000, warn_at: 0.75 }, // no key; rate-limited
    CLOUDFLARE_WORKERS: { daily: 100_000, warn_at: 0.75 },
    CLOUDFLARE_D1_READS: { daily: 5_000_000, warn_at: 0.75 },
    CLOUDFLARE_D1_WRITES: { daily: 100_000, warn_at: 0.75 },
    TWELVE_DATA: { daily: 800, warn_at: 0.75 },
    ALPHAVANTAGE: { daily: 25, warn_at: 0.75 },
    COINGECKO: { daily: 10_000, warn_at: 0.75 },
};
export const PREBUILT_TRACKERS = [
    {
        id: "us-china",
        scope: "US-China",
        query: '"united states" china (tariff OR sanctions OR trade OR taiwan)',
        affected: ["USD", "CNY", "SPX", "XAU"],
    },
    {
        id: "russia-ukraine",
        scope: "Russia-NATO/Ukraine",
        query: "(russia OR ukraine OR nato) (war OR sanctions OR energy OR gas)",
        affected: ["EUR", "USD", "XAU", "WTI", "NATGAS"],
    },
    {
        id: "middle-east",
        scope: "Middle East / Iran-Israel",
        query: '(iran OR israel OR "strait of hormuz" OR opec) (oil OR crude OR energy)',
        affected: ["WTI", "BRENT", "XAU", "USD"],
    },
    {
        id: "taiwan-strait",
        scope: "Taiwan Strait",
        query: '(taiwan OR "taiwan strait") (china OR military OR conflict)',
        affected: ["USD", "CNY", "SPX", "XAU", "TWD"],
    },
    {
        id: "trade-war",
        scope: "Tariff / Sanctions / Trade-war",
        query: "(sanctions OR embargo OR tariff OR \"trade war\")",
        affected: ["USD", "EUR", "CNY", "SPX"],
    },
];
// Cache TTLs in seconds
export const CACHE_TTL = {
    HEALTH: 0,
    MACRO_DAILY: 60 * 60 * 6, // 6 hours
    CALENDAR: 60 * 60 * 6, // 6 hours
    GDELT: 60 * 60, // 1 hour
    COT: 60 * 60 * 24, // 1 day (weekly release)
    SPEECHES: 60 * 60 * 24, // 1 day
    PRICES_HOT: 60 * 5, // 5 minutes
    LIQUIDITY: 60 * 60 * 24, // 1 day
    WEATHER: 60 * 15, // 15 minutes
};
//# sourceMappingURL=constants.js.map